import { render, staticRenderFns } from "./SvgImgIcons.vue?vue&type=template&id=4c188427&"
import script from "./SvgImgIcons.vue?vue&type=script&lang=js&"
export * from "./SvgImgIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports